import { PowerType } from '@allesauto/graphql';

import {
  DELETE_FILTER_DRIVE,
  RESET_FILTER_DRIVE,
  SET_FILTER_DRIVE,
} from '@/store/redux/actions/pages/pcp/filters/drive';
import {
  deleteFromFilterArrayHandler,
  IReduxActionProps,
} from '@/store/redux/Utils';

interface PowerRangeFilters {
  key: PowerType;
  min: number | null;
  max: number | null;
}

export interface DriveStateProps {
  gearBox: string[];
  power: PowerRangeFilters;
  maxCubicCapacity: number | null;
}

export const InitialDriveState: DriveStateProps = {
  gearBox: [],
  power: {
    min: null,
    max: null,
    key: PowerType.Ps,
  },
  maxCubicCapacity: null,
};

const DriveState = (
  state: DriveStateProps = InitialDriveState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_FILTER_DRIVE:
      return {
        ...state,
        ...action.payload,
      };

    case DELETE_FILTER_DRIVE: {
      const payloadKey = action.payload && Object.keys(action.payload)[0];

      // power and max cubic capacity case
      if (payloadKey === 'power' || payloadKey === 'maxCubicCapacity') {
        return {
          ...state,
          [payloadKey]: InitialDriveState[payloadKey],
        };
      }

      // gear box case
      return (
        action.payload && deleteFromFilterArrayHandler(state, action.payload)
      );
    }

    case RESET_FILTER_DRIVE:
      return InitialDriveState;
    default:
      return state;
  }
};

export default DriveState;
